<div class="flags-container">
    <div class="flags-header" [class.full-admin-header]="isFullAdmin">
        <div class="title-wrapper">
            <h2 class="title">Feature Flags</h2>
            <div class="info-section">
                <span>
                    <strong>Session-based toggles.</strong>
                    Some require reload.
                    <em>Overrides persist in local storage and can be reset.</em>
                    <a [href]="CONFLUENCE_DOC_URL" target="_blank" rel="noopener">
                        Docs <app-external-link-icon height="15px" width="15px" color="#0071d0" />
                    </a>
                </span>
            </div>
        </div>
        <div class="header-menu">
            <div class="header-menu-section">
                <div class="category-toggle" *ngIf="isFullAdmin">
                    <div class="category-option" [class.selected]="selectedFlagCategory === 'grouped'"
                        [class.unselected]="selectedFlagCategory === 'all'" (click)="displayGroupedFlags()">
                        <span>Grouped</span>
                    </div>
                    <div class="category-option" [class.selected]="selectedFlagCategory === 'all'"
                        [class.unselected]="selectedFlagCategory === 'grouped'" (click)="displayAllFlags()">
                        <span>All</span>
                    </div>
                </div>
                <div class="flag-search-bar">
                    <input type="text" placeholder="Search..." [(ngModel)]="flagSearchTerm"/>
                </div>
                <div class="reset-button" [class.disabled]="areFlagsUnchanged" (click)="reset()">
                    <span class="undo-label">Undo Changes</span>
                    <app-reset-icon height="15px" width="15px" color="#333" />
                </div>
            </div>
            <div *ngIf="isFullAdmin" class="header-menu-section status-section">
                <div class="status active" [class.selected]="statusFilter === 'active'"
                    [class.unselected]="statusFilter === 'inactive'" (click)="filterByStatus('active')">
                    <span>Active ({{flagByStatusCount('active')}})</span>
                </div>
                <div class="status inactive" [class.selected]="statusFilter === 'inactive'"
                    [class.unselected]="statusFilter === 'active'" color="custom" (click)="filterByStatus('inactive')">
                    <span>Inactive ({{flagByStatusCount('inactive')}})</span>
                </div>
            </div>
        </div>
    </div>
    <div id="all-flags-wrapper" class="flags-flex-wrapper" *ngIf="selectedFlagCategory === 'all'">
        <div class="flags-wrapper">
            <app-flag *ngFor="let key of filteredAllFlagsFirstColumn; trackBy: trackByKey" [key]="key" [modified]="isFlagModified(key)"
                [active]="isActiveFlag(key)" [helpText]="flagHelpMapping[key]" (toggled)="toggleFlag(key)" />
        </div>
        <div class="flags-wrapper">
            <app-flag *ngFor="let key of filteredAllFlagsSecondColumn trackBy: trackByKey" [key]="key" [modified]="isFlagModified(key)"
                [active]="isActiveFlag(key)" [helpText]="flagHelpMapping[key]" (toggled)="toggleFlag(key)" />
        </div>
    </div>
    <div id="grouped-flags-wrapper" class="grouped-flags-flex-wrapper" *ngIf="selectedFlagCategory === 'grouped'">
        <ng-container *ngFor="let group of filteredGroupedFeatureFlagsMapping | keyvalue">
            <app-flag-group *ngIf="group.value.length > 0" [ngClass]="group.key" [groupName]="group.key"
                [isFullAdmin]="isFullAdmin!" [flagKeys]="group.value"
                [groupDescription]="groupFlagHelpMapping[group.key]" [flagHelpMapping]="flagHelpMapping"
                [modifiedFlags]="getModifiedFlags()" [activeFlags]="featureFlags" (toggleFlag)="toggleFlag($event)"
                (toggleGroup)="toggleGroup($event)" />
        </ng-container>
        <app-flag-group *ngIf="isFullAdmin && filteredUnmappedGroupedFeatureFlags.length > 0" groupName="Other"
            [isFullAdmin]="true" [flagKeys]="filteredUnmappedGroupedFeatureFlags" [flagHelpMapping]="flagHelpMapping"
            [modifiedFlags]="getModifiedFlags()" [activeFlags]="featureFlags" (toggleFlag)="toggleFlag($event)"
            (toggleGroup)="toggleGroup($event)" [isToggleDisabled]="true" [isCollapsed]="true" />
    </div>
</div>